import { render, staticRenderFns } from "./ApplicationFeeRule.vue?vue&type=template&id=5bcc51c3"
import script from "./ApplicationFeeRule.vue?vue&type=script&lang=js"
export * from "./ApplicationFeeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports